//  <reference types="@types/googlemaps" />
import { Component, OnInit, Inject, ElementRef, NgZone, ViewChild } from '@angular/core';

import { DealershipService } from '../services/dealership.service';
import { DealershipOverview, DealerGroupV } from '../models/dealership.model';
import { CustomerServiceIdentity } from '../services/customer.service';
import { ReportStyle, NewCustomer, ReportRetrieveOptions } from '../models/customer.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
// import { } from 'googlemaps';
//import { MapsAPILoader } from '@agm/core';
import { NotificationsService } from 'angular2-notifications';
import { UserServiceIdentity } from '../services/user.service';
import { UserAccessType } from '../models/user.model';
import { AddJobsiteModalComponent } from '../add-jobsite-modal/add-jobsite-modal.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'add-customer-modal',
    templateUrl: './add-customer-modal.component.html',
    styleUrls: ['./add-customer-modal.component.scss']
})
export class AddCustomerModalComponent implements OnInit {
    dealerships: DealershipOverview[];
    dealergroups: DealerGroupV[];
    selectedDealershipId:number = 0;
    selectedDealerGroupId:number = 0;
    imageUrl = '';

    reportStyles: ReportStyle[];
    ropereportStyles:ReportStyle[];
    wearreportStyles:ReportStyle[];
    wsrereportStyles:ReportStyle[];

    selectedReportStyleId:number = 0;
    ropeselectedReportStyleId:number = 0;
    wearselectedReportStyleId:number = 0;
    wsreselectedReportStyleId:number = 0;

    addCustomerForm: FormGroup;

    quoteReportStyles: ReportStyle[];
    selectedQuoteReportStyleId:number = 0;



    hourlyRate: number;
    // hourlyRateFormControl : FormControl;

    public searchControl: FormControl;
    @ViewChild('search')
    public searchElementRef: ElementRef;

    // 2 way binding form inputs
    customerName = '';
    customerReference='';
    phoneNumber = '';
    email = '';
    address = '';
    logoUrl = '';
    userAccessType: UserAccessType;
    savingNewCustomer = false;

    customerNameValid:boolean=true;
    isValid:Boolean=false;
    rdThemorgrphyEnable:number =2
    themorgraphyEnabled:boolean=false;
    isRepairer:boolean=false;
    showAll:boolean=true;
    isBasicUser:number=1;
    constructor(public dialogRef: MatDialogRef<AddCustomerModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private _dealershipService: DealershipService, private _customerService: CustomerServiceIdentity, //private mapsAPILoader: MapsAPILoader,
        private ngZone: NgZone, public snackBar: MatSnackBar, public dialog: MatDialog,
        private _notifications: NotificationsService, private _userService: UserServiceIdentity) { }

    ngOnInit() {

        this._customerService.CheckThermographyEnable().subscribe(result => {
            this.themorgraphyEnabled = result;
        });

        this._customerService.CheckUCUserType().subscribe(result => {
            this.isBasicUser = result;
            if(this.isBasicUser==1)this.showAll=true
            else this.showAll=false;
        });
        this._dealershipService.getAllDealerships().subscribe(result => {
            this.dealerships = result;
            if(  this.dealerships.length>0 &&this.dealerships.length==1){
                this.selectedDealershipId= this.dealerships[0].DealershipId;
                this.dealerSelected(  this.selectedDealershipId);
            }
        });
        this._userService.getUserAccessType().subscribe(response => {
            this.userAccessType = response;
        });
        this._dealershipService.getAllDealerGroups().subscribe(result => {
            this.dealergroups = result;
            if (this.dealergroups.length > 0) {
                this.selectedDealerGroupId = this.dealergroups[0].Id;
                this.dealerGroupSelected(this.selectedDealerGroupId);
            }

        });
        this.searchControl = new FormControl();


        // this.hourlyRateFormControl =  new FormControl('', [
        //     Validators.required,
        //     Validators.pattern("/^[0-9]+(\.[0-9]{1,2})?$/")
        // ]);
        // this.addCustomerForm = new FormGroup({
        //     hourlyRateFormControl:this.hourlyRateFormControl ,
        // });

        // this.mapsAPILoader.load().then(() => {
        //     const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        //         types: ['address']
        //     });
        //     google.maps.event.addListener(autocomplete, 'place_changed', () => {
        //         this.ngZone.run(() => {
        //             const place = autocomplete.getPlace();
        //             this.address = place.formatted_address;
        //         });
        //     });
        // });
    }
    ShowAllFields(){
        this.showAll=true;
    }
    

    onNoClick(): void {
        this.dialogRef.close();
    }

    dealershipSelected(dealershipId) {
        this.loadReportsForDealership(dealershipId);
        this.loadQuoteReportStylesForDealership(dealershipId);
        this.loadRopeReportsForDealership(dealershipId);
        this.loadWearReportsForDealership(dealershipId);
        this.loadWsreReportsForDealership(dealershipId);
    }

    dealerGroupSelected(dealerGroupId) {
        this.reportStyles = [];
        this.selectedReportStyleId = 0;
        this._customerService.getReportStyleForCustomerByDealerGroup(dealerGroupId, ReportRetrieveOptions.ConditionReport).subscribe(result => {
            this.reportStyles = result;
            console.log("reportstyles",this.reportStyles)
        });


        this._customerService.getReportStyleForCustomerByDealerGroup(dealerGroupId, ReportRetrieveOptions.RopeReport).subscribe(result => {
            this.reportStyles = result;
            console.log("ropereportstyles",this.reportStyles)
        }); 


        this._customerService.getReportStyleForCustomerByDealerGroup(dealerGroupId, ReportRetrieveOptions.WearReport).subscribe(result => {
            this.reportStyles = result;
            console.log("wearreportstyles",this.reportStyles)
        });  

        this._customerService.getReportStyleForCustomerByDealerGroup(dealerGroupId, ReportRetrieveOptions.WsreReport).subscribe(result => {
            this.reportStyles = result;
            console.log("wsrereportstyles",this.reportStyles)
        });  



        this.quoteReportStyles = [];
        this.selectedQuoteReportStyleId = 0;
        this._customerService.getReportStyleForCustomerByDealerGroup(dealerGroupId, ReportRetrieveOptions.QuoteReport).subscribe(result => {
            this.quoteReportStyles = result;
        });
    }
    dealerSelected(dealerId) {
        this.reportStyles = [];
        this.selectedReportStyleId = 0;
        this._customerService.getReportStyleForCustomerByDealership(0, dealerId, ReportRetrieveOptions.ConditionReport).subscribe(result => {
            this.reportStyles = result;
            this.selectedReportStyleId = this.reportStyles[0].ReportId;
            console.log("reportstyles",this.reportStyles)
        });

        this.ropereportStyles = [];
        this.ropeselectedReportStyleId = 0;
        this._customerService.getReportStyleForCustomerByDealership(0, dealerId, ReportRetrieveOptions.RopeReport).subscribe(result => {
            this.ropereportStyles = result;
            console.log("ropereportstyles",this.ropereportStyles)
        });

        this.wearreportStyles = [];
        this.wearselectedReportStyleId = 0;
        this._customerService.getReportStyleForCustomerByDealership(0, dealerId, ReportRetrieveOptions.WearReport).subscribe(result => {
            this.wearreportStyles = result;
            console.log("wearreportstyles",this.wearreportStyles)
        });

        this.wsrereportStyles = [];
        this.wsreselectedReportStyleId = 0;
        this._customerService.getReportStyleForCustomerByDealership(0, dealerId, ReportRetrieveOptions.WsreReport).subscribe(result => {
            this.wsrereportStyles = result;
            console.log("wsrereportstyles",this.wsrereportStyles)
        });

        this.quoteReportStyles = [];
        this.selectedQuoteReportStyleId = 0;
        this._customerService.getReportStyleForCustomerByDealership(0, dealerId, ReportRetrieveOptions.QuoteReport).subscribe(qr => {
            this.quoteReportStyles = qr;
        });

        console.log("Customert__",this.customerName )
        //check customer name validation 
        if(this.customerName!=null || this.customerName!=""){
            this.validateCustomerName();
        }
    }


 validateCustomerName() {
   
    this._customerService.validateCustomerNameDealerGroup(this.selectedDealershipId, this.customerName).subscribe(qr => {
        this.customerNameValid = qr;
    });
  }


    loadReportsForDealership(dealershipId) {
        this._customerService.getReportStyleForCustomerByDealership(0, dealershipId, ReportRetrieveOptions.ConditionReport).subscribe(result => {
            this.reportStyles = result;
            console.log("reportstyles",this.reportStyles)
        });
    }


    loadRopeReportsForDealership(dealershipId) {
        this._customerService.getReportStyleForCustomerByDealership(0, dealershipId, ReportRetrieveOptions.RopeReport).subscribe(result => {
            this.ropereportStyles = result;
            console.log("reportstyles",this.reportStyles)
        });
    }

    loadWearReportsForDealership(dealershipId) {
        this._customerService.getReportStyleForCustomerByDealership(0, dealershipId, ReportRetrieveOptions.WearReport).subscribe(result => {
            this.wearreportStyles = result;
            console.log("reportstyles",this.reportStyles)
        });
    }

    loadWsreReportsForDealership(dealershipId) {
        this._customerService.getReportStyleForCustomerByDealership(0, dealershipId, ReportRetrieveOptions.WsreReport).subscribe(result => {
            this.wsrereportStyles = result;
            console.log("reportstyles",this.reportStyles)
        });
    }
    loadQuoteReportStylesForDealership(dealershipId) {
        this._customerService.getReportStyleForCustomerByDealership(0, dealershipId, ReportRetrieveOptions.QuoteReport).subscribe(result => {
            this.quoteReportStyles = result;
        });
    }



    onSelectImage(event) {
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader();

            reader.readAsDataURL(event.target.files[0]); // read file as data url

            reader.onload = (event: any) => { // called once readAsDataURL is completed
                this.imageUrl = event.target["result"];
            };
        }
    }
required:boolean=false;
    addNewCustomer() {
        if (this.savingNewCustomer) {
            return;
        }
        if (this.selectedDealershipId > 0) {
            this.selectedDealerGroupId = 0;
        }

        if((this.selectedDealershipId < 1 && this.userAccessType <= 3)){
            this.required=true;
        }
        console.log("details",this.selectedDealershipId,this.userAccessType, this.required, this.selectedReportStyleId, this.customerName.length )
        if ( this.required ||this.customerName.length < 1 || this.selectedReportStyleId <1) {
            this.snackBar.open('Please fill in all required fields (*)', '', {
                duration: 1500,
            });
            return;
        }
      
       
        this.savingNewCustomer = true;

        

        const newCustomer: NewCustomer = {
            Address: this.address,
            CustomerName: this.customerName,
            DealershipId: this.selectedDealershipId,
            Email: this.email,
            DealerGroupId: this.selectedDealerGroupId,
            ReportStyleId: this.selectedReportStyleId,
            PhoneNumber: this.phoneNumber,
            Logo: this.imageUrl,
            CreatedByUserId: 0,
            QuoteReportStyleId: this.selectedQuoteReportStyleId,
            HourlyLabourCost : this.hourlyRate,
            RopeReportStyleId:this.ropeselectedReportStyleId,
            WearReportStyleId:this.wearselectedReportStyleId,
            WsreReportStyleId:this.wsreselectedReportStyleId,

            ThermographyEnable:this.rdThemorgrphyEnable,
            IsRepairer:this.isRepairer,
            customerReference:this.customerReference,

        };
        this._customerService.addNewCustomer(newCustomer).subscribe(result => {
            this.savingNewCustomer = false;
            if (result.m_Item1 === -1) {
                this._notifications.error('Failed', result.m_Item2);
            } else {
                this._notifications.success('Customer Added', result.m_Item2);
                this.dialogRef.close(true);

                this.openAddJobsiteModal(result.m_Item1);
            }
        });
    }

    openAddJobsiteModal(customerId): void {
        const dialogRef = this.dialog.open(AddJobsiteModalComponent, {
            width: '700px',
            height:'817px',
            data: {
                customerId: customerId
            }
        });
        dialogRef.afterClosed().subscribe(doUpdate => {
            
        });
    }
}

interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage(): string;
}
